import { getCopyText } from "lib/getCopyText"
import useCurrent from "lib/use-current"

const getExpoCopyText = (current: Exclude<ReturnType<typeof useCurrent>, undefined>) => {
  return getCopyText(current.config.expo_copy_text)
}

export default getExpoCopyText
